import createIcon from "../createIcon";

export default createIcon("la la-angle-left");
